export const slugify = (s = "") =>
    String(s)
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .replace(/-+/g, "-");

export const cleanPhone = (p = "") => String(p).replace(/[^\d]/g, "");

export const extractIframeSrc = (html = "") => {
    if (!html) return null;
    const match = String(html).match(/src="([^"]+)"/);
    return match ? match[1] : null;
};

export const updateArrayItem = (arr = [], index, patch) =>
    arr.map((x, i) => (i === index ? { ...x, ...patch } : x));

export const removeArrayItem = (arr = [], index) =>
    arr.filter((_, i) => i !== index);

export const addArrayItem = (arr = [], item) => [...arr, item];

export const DEFAULT_CATS = ["pengurusan", "imam", "bilal"];

// untuk label display
export const titleCase = (s = "") =>
    String(s)
        .trim()
        .split(" ")
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");

export const normalizeCategoryKey = (s = "") => slugify(String(s || "")) || "pengurusan";

/**
 * Roles rule:
 * - Kalau category = imam => roles auto ["imam"]
 * - Kalau category = bilal => roles auto ["bilal"]
 * - Kalau category lain => roles default ["pengurusan"] (boleh tambah imam/bilal via checkbox)
 */
export const rolesFromCategory = (categoryKey = "pengurusan") => {
    const k = normalizeCategoryKey(categoryKey);
    if (k === "imam") return ["imam"];
    if (k === "bilal") return ["bilal"];
    return ["pengurusan"];
};

/**
 * Hirarki role:
 * - Kalau dia dari pengurusan/custom tapi ditick imam/bilal => imam/bilal hirarki jadi 0 (lebih tinggi)
 * - Kalau category memang imam/bilal => guna base hirarki (p.hirarki)
 */
export const buildHirarkiByRole = ({ category, roles, baseHirarki }) => {
    const cat = normalizeCategoryKey(category);
    const r = new Set(roles || rolesFromCategory(cat));
    const base = Number(baseHirarki ?? 99);

    const isPrimaryImam = cat === "imam";
    const isPrimaryBilal = cat === "bilal";

    const imamRank = r.has("imam") ? (isPrimaryImam ? base : 0) : 99;
    const bilalRank = r.has("bilal") ? (isPrimaryBilal ? base : 0) : 99;

    // pengurusan/custom: ikut base (untuk group category)
    const pengurusanRank = base;

    return {
        pengurusan: pengurusanRank,
        imam: imamRank,
        bilal: bilalRank,
    };
};
